
export const readFile = async (uri: string)=>{
    return uri ? '' : '';
};
